import * as yup from 'yup'
import {
  INVALID_SYMBOLS,
  NUMBERS_ONLY,
  NUMBER_CANNOT_BE_NEGATIVE,
  FROM_VALUE_MUST_BE_LESS_THAN_TO,
  TO_VALUE_MUST_BE_MORE_THAN_FROM,
} from 'constants/errors'
import { validateDecimalPlaces } from 'utils/validateFloatWithPlaces'
import { DECIMAL_PLACES } from 'constants/calcConstants'

export const schemaLatestDealsFilters = yup.object().shape({
  from: yup
    .number()
    .test('float', INVALID_SYMBOLS, function (value) {
      if (value === null || value === undefined) return true
      return validateDecimalPlaces(value, DECIMAL_PLACES)
    })
    .test('not more than to', FROM_VALUE_MUST_BE_LESS_THAN_TO, function () {
      const to = +this.parent.to || Number.MAX_SAFE_INTEGER
      const from = +this.parent.from || 0
      return to >= from
    })
    .typeError(NUMBERS_ONLY)
    .min(0, NUMBER_CANNOT_BE_NEGATIVE),
  to: yup
    .number()
    .test('float', INVALID_SYMBOLS, function (value) {
      if (value === null || value === undefined) return true
      return validateDecimalPlaces(value, DECIMAL_PLACES)
    })
    .test('not less than from', TO_VALUE_MUST_BE_MORE_THAN_FROM, function () {
      const to = +this.parent.to || Number.MAX_SAFE_INTEGER
      const from = +this.parent.from || 0
      return to >= from
    })
    .typeError(NUMBERS_ONLY)
    .min(0, NUMBER_CANNOT_BE_NEGATIVE),
})
